import { Alert, Button, Dialog, MobileStepper, Paper, styled } from "@mui/material";
import { DroneInfo } from "adoms-common-lib";
import React, { useEffect, useState } from "react";
import DroneBasicInformationContent from "../molecule/DroneBasicInformationContent";
import DroneCertificationInformationContent from "../molecule/DroneCertificationInformationContent";
import DroneDetailInformationContent from "../molecule/DroneDetailInformationContent";
import { APIConnector } from "../../connector/APIConnector";
import axios from "axios";

// propsの型を定義
type DroneCreateDialogporps = {
    isOpen: boolean;
    closeHandler: () => void;
    allDroneList: DroneInfo[] | undefined;
    setEditDroneList: React.Dispatch<React.SetStateAction<boolean>>;
    setDisplayLoadingMark: React.Dispatch<React.SetStateAction<boolean>>;
};

// MobileStepperのスタイル
const PortMobileStepper = styled(MobileStepper)(({ theme }) => ({
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
}));


// 機体情報ダイアログ
const DroneCreateDialog: React.FC<DroneCreateDialogporps> = (props) => {
    const [newDrone, setNewDrone] = useState<DroneInfo>({
        registrationId: "",
        tenantId: "",
        sort: 0,
        label: "",
        kind: "",
        payload: 0,
        img1: "/img/drone/defaultDrone.jpg",
        owner: "",
        businessPartnerInfoList: [],
        designManufacturer: "",
        serialNumber: ""
    });
    const [activeStep, setActiveStep] = useState(0);
    const [isNextDisable, setIsNextDisable] = useState(true);
    const [isConfirmDisable, setIsConfirmDisable] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    // ダイアログが閉じられたとき
    const handleClose = () => {
        setErrorMessage(undefined);
        props.closeHandler();
    };

    // 次へを押したとき
    const nextHandler = () => {
        setActiveStep((prevSteps) => prevSteps + 1);
    };

    // 戻るを押したとき
    const backHandler = () => {
        setActiveStep((prevSteps) => prevSteps - 1);
    };

    // ダイアログが閉じるたびにstate初期化
    useEffect(() => {
        if (!props.isOpen) {
            setActiveStep((prevSteps) => (prevSteps = 0));
            setIsNextDisable(true);
            setNewDrone({
                registrationId: "",
                tenantId: "",
                sort: 0,
                label: "",
                kind: "",
                payload: 0,
                img1: "/img/drone/defaultDrone.jpg",
                owner: "",
                businessPartnerInfoList: [],
                designManufacturer: "",
                serialNumber: ""
            });
        }
    }, [props.isOpen]);

    // 登録処理
    const handleConfirm = async (event: any) => {
        if (newDrone) {
            props.setDisplayLoadingMark(true);

            // ソートキーを設定する
            let maxSort = 0;

            if (props.allDroneList) {
                for (let drone of props.allDroneList) {
                    if (maxSort < drone.sort) {
                        maxSort = drone.sort;
                    };
                };
            };

            newDrone.sort = maxSort + 1;

            let apigw: APIConnector = APIConnector.instance;
            await apigw.createDrone(newDrone).then(() => {
                props.closeHandler();
                props.setEditDroneList(true);
                setErrorMessage(undefined);
            }).catch((error) => {
                console.log(error);
                if (axios.isAxiosError(error) && typeof error.response !== "undefined" && error.response.status === 403) {
                    setErrorMessage("権限がありません");
                    props.setDisplayLoadingMark(false);
                } else {
                    setErrorMessage("DB更新に失敗しました");
                    props.setDisplayLoadingMark(false);
                }
            });
        }
    };

    return (
        <Dialog
            open={props.isOpen}
            onClose={() => {
                handleClose();
            }}
            aria-labelledby="ドローン新規登録ダイアログ"
        >
            {errorMessage ?
                <Alert severity="error" sx={{ margin: "20px" }}>{errorMessage}</Alert> :
                null}

            {/* ドローン基本情報 */}
            {activeStep === 0 && (
                <DroneBasicInformationContent
                    droneData={newDrone}
                    allDroneList={props.allDroneList}
                    setDroneData={setNewDrone}
                    setIsNextDisable={setIsNextDisable}
                />
            )}

            {/* ドローン詳細情報 */}
            {activeStep === 1 && (
                <DroneDetailInformationContent
                    droneData={newDrone}
                    setNewDrone={setNewDrone}
                    setIsNextDisable={setIsNextDisable}
                    isTextFieldDisabled={false}
                />
            )}

            {/* ドローン認証情報 */}
            {activeStep === 2 && (
                <DroneCertificationInformationContent
                    droneData={newDrone}
                    setNewDrone={setNewDrone}
                    setIsConfirmDisable={setIsConfirmDisable}
                />
            )}

            {/* ダイアログボタン関連 */}
            <PortMobileStepper
                variant="dots"
                steps={3}
                position="static"
                activeStep={activeStep}
                nextButton={
                    activeStep === 2 ? (
                        <Button
                            color="secondary"
                            size="small"
                            onClick={handleConfirm}
                            disabled={isConfirmDisable}
                        >
                            確定
                        </Button>
                    ) : (
                        <Button
                            color="primary"
                            size="small"
                            onClick={nextHandler}
                            disabled={isNextDisable}
                        >
                            次へ
                        </Button>
                    )}
                backButton={
                    <Button
                        color="primary"
                        size="small"
                        onClick={backHandler}
                        disabled={activeStep === 0}
                    >
                        戻る
                    </Button>
                }
            />
        </Dialog>
    );
};

export default DroneCreateDialog;